export interface LiveStreamHistoryState {
  nameFilter: string | null;
}

export const initialLiveStreamHistoryState: LiveStreamHistoryState = {
  nameFilter: null
};
